<template>
    <div id="app">
      <keep-alive>
        <router-view class="avue-view" v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <router-view class="avue-view" v-if="!$route.meta.keepAlive"/>
    </div>
</template>

<script>
export default {
    provide() {
        return {
            
        };
    },
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    mounted() {
        
    },
    methods: {
        
    },
};
</script>


<style lang="scss" scoped>
  #app {
      font-size: 14px;
  }
</style>
